import { BASE_URL } from './index'

const hrefLangs = [
  {
    country: 'x-default',
    href: `${BASE_URL}`,
  },
  {
    country: 'AR',
    href: 'https://www.bumeran.com.ar',
  },
  {
    country: 'CL',
    href: 'https://www.laborum.cl',
  },
  {
    country: 'EC',
    href: 'https://www.multitrabajos.com',
  },
  {
    country: 'PA',
    href: 'https://www.konzerta.com',
  },
  {
    country: 'MX',
    href: 'https://www.bumeran.com.mx',
  },
  {
    country: 'PE',
    href: 'https://www.bumeran.com.pe',
  },
  {
    country: 'VE',
    href: 'https://www.bumeran.com.ve',
  },
]

export default hrefLangs
